import { createSlice } from "../helper";

const expenseViewSlice = createSlice({
  name: "expenseView",
  initialState: {},
  reducers: {
    replaceState: (_state, action) => {
      return action.payload;
    },
    updateStatuses: (state, action) => {
      state.filters.statuses = action.payload;
    },
    updateBudgetId: (state, action) => {
      state.filters.budgetId = action.payload;
    },
    updatePrograms: (state, action) => {
      state.filters.programs = action.payload;
    },
    updateGroups: (state, action) => {
      state.filters.groups = action.payload;
    },
    updateSelectedValuesForQuestionId: (state, action) => {
      state.filters.questionIdSelectedValues[action.payload.questionId] = action.payload.selectedValues;
    },
    updateDescription: (state, action) => {
      state.filters.description = action.payload;
    }
  }
});

export const expenseViewActions = expenseViewSlice.actions;

export default expenseViewSlice.reducer;
